import React, { useEffect, useState } from 'react';
import Aux from 'components/hoc/AuxFunction';
import { Button } from 'antd';
import StatusModal from 'components/Appointments/Modals/StatusModal';
import { Alert } from 'components/Layout/Alert';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Badge, DatePicker, Input, Menu, Select, Tooltip, Tag } from 'antd';
import {
  EditOutlined,
  FileOutlined,
  FileTextOutlined,
  MessageOutlined,
  PaperClipOutlined
} from '@ant-design/icons';

import { useSelector, useDispatch } from 'react-redux';
import CreateMessageModal from '../Appointment/components/Messages/CreateMessageModal';
import CreateNoteModal from '../Appointment/components/Notes/CreateNoteModal';
import CreateCollateralModal from '../Appointment/components/Collateral/CreateCollateralModal';
import moment from 'moment';
import { getAllLocations, getLocationTypeList } from '../../api/locations';
import CRUDDataTable from '../../components/DataTable/CRUDDataTable';
import CreateVisitorForm from '../Visitors/components/CreateVisitorForm';
import { getAppointmentsDatatable, getAppointmentTypes } from '../../api/appointments';
import HospitalSelect from '../../components/location/hospitalSelect';
import ActionButtonsDropdown from 'components/ActionButtonsDropdown';
import { FcFile } from 'react-icons/fc';
import DocumentIcon from 'assets/icons/document-icon';
import MessageIcon from 'assets/icons/message-icon';
import ResourceIcon from 'assets/icons/resource-icon';
import AttachmentIcon from 'assets/icons/attachment-icon';
import PatientIcon from 'assets/icons/patient-icon';
import NurseIcon from 'assets/icons/nurse-icon';
import CreateFormModal from 'pages/Appointment/components/Forms/CreateFormModal';
import ListAltTwoToneIcon from '@material-ui/icons/ListAltTwoTone';
import PermissifiedComponent from 'components/PermissifiedComponent';
import { isCurrentPermissionKeyPermitted, permissifyTableColumns } from 'utils';
import { FaFileCsv } from 'react-icons/all';
import UploadPatientCSVModal from 'components/Appointments/Modals/UploadPatientCSV';

const AppointmentsList = (props) => {
  const {
    setMessageModalVisibility,
    setCollateralModalVisibility,
    setNoteModalVisibility,
    setActiveAppointmentId,
  } = props;
    const permissionState = useSelector(state => state.permissions);
    const { RangePicker } = DatePicker;
    const [
        isCreateMessageModalVisible,
        setCreateMessageModalVisibility,
    ] = useState(false);
    const [isCreateNoteModalVisible, setCreateNoteModalVisibility] = useState(
        false
    );
    const [
        isCreateCollateralModalVisible,
        setCreateCollateralModalVisibility,
    ] = useState(false);
    const [isStatusModalVisible, setStatusModalVisibility] = useState(false);
    const [draw, setDraw] = useState(0);
    const [uploadPatientCSVModalVisibility, setUploadPatientCSVModalVisibility] = useState(false);
    
    //const newFilter = [];
    //newFilter.push({ paramName: 'startDate', value: moment().format('yyyy-MM-DD') });
    //newFilter.push({ paramName: 'endDate', value: moment().format('yyyy-MM-DD') });    
    const [customFilters, setCustomFilters] = useState([]);

    const [timeFilters, setTimeFilters] = useState([]);
    const dispatch = useDispatch();

    const [id, setId] = useState(0);
    const [hospitalOptions, setHospitalOptions] = useState([]);
    const [locationType, setLocationType] = useState([]);
    const [appointmentsType, setAppointmentsType] = useState([]);
    const [nameSearch, setNameSearch] = useState('');
    const satisfied = async () => {
        let response = await getAllLocations();
        let responseLocType = await getLocationTypeList();
        let responseAppType = await getAppointmentTypes();
        // two nested data calls because it's returning a datatable
        // console.log(response.data.data)
        setHospitalOptions(response.data.data);
        setLocationType(responseLocType.data.data);
        setAppointmentsType(responseAppType.data.data);
    };
    useEffect(() => {
        satisfied();
    }, []);

    //useEffect(() => {
    //    initFilters();
    //}, []);

    //const initFilters = () => {
    //    const newFilter = [...customFilters];

    //    newFilter.push({ paramName: 'startDate', value: moment().format('yyyy-MM-DD') });
    //    newFilter.push({ paramName: 'endDate', value: moment().format('yyyy-MM-DD') });

    //    setCustomFilters(newFilter);
    //}

  const [isCreateFormModalVisible, setCreateFormModalVisibility] = useState(false);

  const renderMenu = (id, appointmentTitle) => (
    <Menu>
      <Menu.Item>
        <Link
          to={`/appointments/${id}`}
          onClick={() => setActiveAppointmentId(id)}
        >
          View
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setStatusModalVisibility({
              id: id,
              isVisible: true,
            });
          }}
        >
          Change Status
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setCreateMessageModalVisibility(true);
            setId(id);
          }}
        >
          Send Message
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setCreateCollateralModalVisibility(true);
            setId(id);
          }}
        >
          Attach Collateral
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setCreateNoteModalVisibility(true);
            setId(id);
          }}
        >
          Add Note
        </Link>
      </Menu.Item>
    </Menu>
  );

  const notificationTypes = [
    {
      name: 'newForms',
      icon: <DocumentIcon />,
    },
    {
      name: 'newMessages',
      icon: <MessageIcon />,
    },
    {
      name: 'newResources',
      icon: <ResourceIcon />,
    },
    {
      name: 'newAttachments',
      icon: <AttachmentIcon />,
    },
    {
      name: 'incompletePatientTasks',
      icon: <PatientIcon />,
    },
    {
      name: 'incompleteStaffTasks',
      icon: <ListAltTwoToneIcon />,
    },
  ];


  const columns =  [
    {
      permissionKey: 'appointments:list:column:first_name',
      title: <strong>MRN</strong>,
      dataIndex: 'mrn',
      key: 'mrn',
      sorter: true,
    },
    {
      permissionKey: 'appointments:list:column:first_name',
      title: <strong>Patient Name</strong>,
      dataIndex: 'firstName',
      key: 'firstName',
      sorter: true,
      render: (text, record, index) => {
        return (
          <>
            <Link
              to={`/appointments/${record?.id}`}
              onClick={() => {
                // setActiveAppointmentId(record?.id)
              }}
            >
              {record?.firstName} {record?.lastName}
            </Link>
          </>
        );
      },
      filter: {
        paramName: 'search',
        label: 'Patient',
        // hidden: true,
        component: {
          name: 'text',
          placeholder: 'Enter patient name',
        },
      },
    },
    {
      permissionKey: 'appointments:list:column:date_time',
      title: <strong>Appointment Time & Date</strong>,
      dataIndex: 'appointmentDateTime',
      key: 'appointmentDateTime',
      sorter: true,
      render: (text, record, value) =>
        moment(text).format('DD MMM YYYY h:mm A'),
      filter: {
        paramName: 'date',
        label: 'Date',
        component: {
          name: 'daterange',
          defaultValue: [moment(), moment()],
          format: 'DD/MM/YYYY',
        },
        defaultValue: [moment(), moment()],
        displayFormat: (value) => {
          const dates = value && value.map((date) => date.format('DD-MM-yyyy'));
          return `${dates[0]} to ${dates[1]}`;
        },
        beforeRequest: (value) =>
          value &&
          value
            .map((date) => date.format('yyyy-MM-DD'))
            .reduce((result, date, i) => {
              if (i === 0) result.startDate = date;
              else result.endDate = date;

              return result;
            }, {}),
      },
    },
    {
      permissionKey: 'appointments:list:column:appointment_type',
      title: <strong>Appointment Type</strong>,
      dataIndex: 'appointmentType',
      key: 'appointmentType',
      sorter: true,
      render: (text, record, value) => {
        return (
          <>
            <div>{record?.appointmentType}</div>
            <Tag color={record?.attendanceType === 'CLINIC' ? 'blue' : 'green'}>
              {record?.attendanceType}
            </Tag>
          </>
        );
      },
      filter: {
        paramName: 'appointmentType',
        label: 'Appointment Type',
        component: {
          name: 'select',
          placeholder: 'Select an Appointment Type',
          fetchData: () => {
              return appointmentsType.map((item) => {
                return {
                  value: item.key,
                  displayText: item.display,
                };
              });
          },
        },        
      },
    },
    {
      permissionKey: 'appointments:list:column:clinician',
      title: <strong>Clinician Name</strong>,
      dataIndex: 'attendingDoctorName',
      key: 'attendingDoctorName',
      sorter: true,
    },
    {
      permissionKey: 'appointments:list:column:status',
      title: <strong>Status</strong>,
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record, value) => {
        return text?.replaceAll('_', ' ');
      },
      filter: {
        paramName: 'status',
        label: 'Status',
        component: {
          name: 'select',
          placeholder: 'Select a status',
          fetchData: () => [
            { value: 'REQUEST_RESCHEDULE', displayText: 'REQUEST RESCHEDULE' },
            { value: 'SCHEDULED', displayText: 'SCHEDULED' },
            { value: 'IN_PROGRESS', displayText: 'IN PROGRESS' },
            { value: 'COMPLETE', displayText: 'COMPLETE' },
            { value: 'CANCELLED', displayText: 'CANCELLED' },
            { value: 'UNCONFIRMED', displayText: 'UNCONFIRMED' },
            { value: 'DECLINED', displayText: 'DECLINED' },
            { value: 'CONFIRMED', displayText: 'CONFIRMED' },
            { value: 'CHECKED_IN_WAITING', displayText: 'CHECKED IN WAITING' },
            {
              value: 'CALLED_BACK_TO_QUEUE',
              displayText: 'CALLED BACK TO QUEUE',
            },
            { value: 'CHECKED_IN', displayText: 'CHECKED IN' },
            { value: 'IN', displayText: 'IN' },
            { value: 'CHECKED_OUT', displayText: 'CHECKED OUT' },
            { value: 'NO_SHOW', displayText: 'NO SHOW' },
            { value: 'START_CONSULT', displayText: 'START CONSULT' },
            { value: 'END_CONSULT', displayText: 'END CONSULT' },
          ],
        },
      },
    },
    {
      permissionKey: 'appointments:list:column:clinician',
      title: <strong>Contact Number</strong>,
      dataIndex: 'contactNumber',
      key: 'contactNumber',
      sorter: true,
    },
    {
      permissionKey: 'appointments:list:column:clinician',  //gurcan
      title: <strong>Clinic Type</strong>,
      dataIndex: 'clinicType',
      key: 'clinicType',
      sorter: true,
      filter: {
        paramName: 'clinicType',
        label: 'Clinic Type',
        component: {
          name: 'select',
          placeholder: 'Select a Clinic Type',
          fetchData: () => {
              return locationType.map((item) => {
                return {
                  value: item.key,
                  displayText: item.display,
                };
              });
          },
        },
      },
    },
    {
      permissionKey: 'appointments:list:column:clinician',
      title: <strong>Fin Class</strong>,
      dataIndex: 'finClass',
      key: 'finClass',
      sorter: true,
    },
    {
      permissionKey: 'appointments:list:column:actionables',
      title: <strong>Tasks / Alerts</strong>,
      width: '100px',
      dataIndex: 'id',
      key: 'id',
      sorter: false,
      render: (text, record, value) => {
        return (
          <div>
            {notificationTypes.map((type) =>
              record[type.name] ? (
                <Tooltip
                  title={`${record[type.name]} ${type.name
                    .split(/(?=[A-Z])/)
                    .map((s) => s.toLowerCase())
                    .join(' ')}`}
                >
                  <Badge count={record[type.name]}>
                    {React.cloneElement(type.icon, {
                      width: 30,
                      height: 25,
                      className: 'm-1 actionables',
                    })}
                  </Badge>
                </Tooltip>
              ) : null
            )}
          </div>
        );
      },
    },
    {
      permissionKey: 'appointments:list:column:options',
      title: <strong>Actions</strong>,
      dataIndex: 'id',
      key: 'id',
      sorter: false,
      render: (text, record, value) => {
        const appointmentOptions = [
          {
            permissionKey: 'appointments:list:column:options:update_status',
            label: 'Update Status',
            icon: <EditOutlined />,
            onClick: () => {
              setStatusModalVisibility(true);
              setId(record.id);
            },
          },
          {
            permissionKey: 'appointments:list:column:options:add_collateral',
            label: 'Add Collateral',
            icon: <PaperClipOutlined />,
            onClick: () => {
              setCreateCollateralModalVisibility(true);
              setId(record.id);
            },
          },
          {
            permissionKey: 'appointments:list:column:options:send_message',
            label: 'Send Message',
            icon: <MessageOutlined />,
            onClick: () => {
              setCreateMessageModalVisibility(true);
              setId(record.id);
            },
          },
          {
            permissionKey: 'appointments:list:column:options:add_note',
            label: 'Add Note',
            icon: <FileTextOutlined />,
            onClick: () => {
              setCreateNoteModalVisibility(true);
              setId(record.id);
            },
          },
          {
            permissionKey: 'appointments:list:column:options:add_form',
            label: 'Add Form',
            icon: <FileOutlined />,
            onClick: () => {
              setCreateFormModalVisibility(true);
              setId(record.id);
            },
          },
        ];

        const permittedOptions = appointmentOptions.filter(
          (appointmentOption) =>
            isCurrentPermissionKeyPermitted(
              appointmentOption.permissionKey,
              permissionState
            )
        );

        return (
          <>
            <ActionButtonsDropdown menus={permittedOptions} />
          </>
        );
      },
    },

    {
      permissionKey: 'appointments:list:column:clinician',
      filter: {
        paramName: 'doctorName',
        label: 'Clinician',
        component: {
          name: 'text',
          placeholder: 'Enter clinician name',
        },
      },
    },
    {
      permissionKey: 'appointments:list:column:filter:span',
      filter: {
        paramName: 'span',
        label: 'Span',
        defaultValue: 'UPCOMING',
        component: {
          name: 'select',
          placeholder: 'Select span',
          fetchData: () => {
            return [
              { value: 'ALL', displayText: 'ALL' },
              { value: 'PAST', displayText: 'PAST' },
              { value: 'UPCOMING', displayText: 'UPCOMING' },
            ];
          },
        },
      },
    },
  ];


  function onBlur() {
    // console.log('blur');
  }

  function onFocus() {
    // console.log('focus');
  }

  function onSearch(val) {
    // console.log('search:', val);
  }

  const fetchAppointments = async(params) => {
    params = {
      ...params,
      sortColumn: 'appointmentDateTime'
    }

    if (params.date && Array.isArray(params.date)) {
      if (params.date[0]){
        params.startDate = params.date[0].format('yyyy-MM-DD');
      }
      if (params.date[1]){
        params.endDate = params.date[1].format('yyyy-MM-DD');
      }      
      delete params.date;
    }
    return await getAppointmentsDatatable(params);
  }

  if ( locationType.length === 0 || appointmentsType.length === 0) {
    return null;
  }

  return (
    <Aux>
      <StatusModal
        isStatusModalVisible={isStatusModalVisible}
        setStatusModalVisibility={setStatusModalVisibility}
        id={id}
        onSuccess={() => setDraw(draw + 1)}
      />
      <Alert />
      <CreateNoteModal
        visible={isCreateNoteModalVisible}
        setVisibility={setCreateNoteModalVisibility}
        icon={<FileTextOutlined className='mr-2' />}
        appointmentId={id}
        onSuccess={() => {
          setDraw(draw + 1);
        }}
      />
      <CreateMessageModal
        visible={isCreateMessageModalVisible}
        setVisibility={setCreateMessageModalVisibility}
        icon={<MessageOutlined className='mr-2' />}
        appointmentId={id}
        onSuccess={() => {
          setDraw(draw + 1);
        }}
      />
      <CreateCollateralModal
        visible={isCreateCollateralModalVisible}
        setVisibility={setCreateCollateralModalVisibility}
        icon={<PaperClipOutlined className='mr-2' />}
        appointmentId={id}
        onSuccess={() => {
          setDraw(draw + 1);
        }}
      />
      <CreateFormModal
        visible={isCreateFormModalVisible}
        setVisibility={setCreateFormModalVisibility}
        icon={<FileOutlined className='mr-2' />}
        appointmentId={id}
        onSuccess={() => {
          setDraw(draw + 1);
        }}
      />
      <UploadPatientCSVModal
        visible={uploadPatientCSVModalVisibility}
        setVisibility={setUploadPatientCSVModalVisibility}
        setDraw={setDraw}
        draw={draw} 
      />
      <PermissifiedComponent permissionKey='appointments:location_filter'>
        <Row>
            <Col md='3'>
                <HospitalSelect
                    width={{width: '275px'}}
                    direction='horizontal'
                    onChange={(value) => {
                    const paramName = 'locationId';
                    const filters = [...customFilters];
                    const hospitalFilter = filters.filter(
                        (filter) => filter.paramName === paramName
                    )[0];

                    if (hospitalFilter) {
                        hospitalFilter.value = value;
                    } else {
                        filters.push({ paramName: paramName, value: value });
                    }

                    setCustomFilters(filters);
                    }}
                />
            </Col>
            <Col 
                className='text-right'
                md='9'
            >
                <Button
                    className='mt-5'
                    type='primary'
                    onClick={() => {
                        setUploadPatientCSVModalVisibility(true);
                    }}
                >
                    <FaFileCsv />&nbsp;&nbsp;Upload Patient CSV
                </Button>
            </Col>
        </Row>
        <br />
      </PermissifiedComponent>
      <CRUDDataTable
        draw={draw}
        entity='Appointments'
        fetchDataFunction={fetchAppointments}
        continuousFetchInterval={60000}
        customFilters={customFilters}
        createModal={<CreateVisitorForm />}
        columns={permissifyTableColumns(columns, permissionState)}
        sortOrder='appointmentDateTime'
        button={<></>}
        highlightRow={(rec, i) => {
          return (
            rec.highlightDeclinedForStaff ||
            rec.newForms > 0 ||
            rec.newMessages > 0 ||
            rec.newAttachments > 0 ||
            rec.incompleteStaffTasks > 0
          );
        }}
      />
    </Aux>
  );
};

export default AppointmentsList;
